import React, { useMemo } from "react";
import { IPrizeCoupon } from "../../../../types";
import MyCouponItem from "../MyCouponItem";
import styles from "./index.module.scss";
import { deduplicateAndGroupCoupons, getLosAngelesDate } from "./utils";

interface MyCouponsProps {
  coupons: IPrizeCoupon[];
  loading?: boolean;
}

const MyCoupons: React.FC<MyCouponsProps> = ({ coupons, loading = false }) => {
  const groups = useMemo(() => deduplicateAndGroupCoupons(coupons), [coupons]);
  const losAngelesDate = getLosAngelesDate();
  const hasCoupons =
    groups.lottery.length > 0 || groups.freeShipping.length > 0;

  if (loading) {
    return <div className={styles.empty}>Loading coupons...</div>;
  }

  if (!hasCoupons) {
    return <div className={styles.empty}>No coupons yet.</div>;
  }

  return (
    <div className={styles.myCoupons}>
      {groups.lottery.length > 0 && (
        <section className={styles.couponSection}>
          <h2 className={styles.sectionTitle}>Mystery Box Rewards</h2>
          <div className={styles.couponGrid}>
            {groups.lottery.map((coupon, index) => (
              <MyCouponItem
                key={
                  coupon.shopify_discount_code_id ??
                  coupon.shopify_discount_code ??
                  coupon.id ??
                  index
                }
                coupon={coupon}
                currentMonth={losAngelesDate.month}
                currentYear={losAngelesDate.year}
              />
            ))}
          </div>
        </section>
      )}

      {groups.freeShipping.length > 0 && (
        <section className={styles.couponSection}>
          <p className={styles.sectionDescription}>
            One coupon each month · one order per coupon.
          </p>
          <div className={styles.couponGrid}>
            {groups.freeShipping
              .sort(
                (cur, pre) =>
                  (cur.free_shipping_type || 0) - (pre.free_shipping_type || 0),
              )
              .map((coupon, index) => (
                <MyCouponItem
                  key={
                    coupon.shopify_discount_code_id ??
                    coupon.shopify_discount_code ??
                    coupon.id ??
                    index
                  }
                  coupon={coupon}
                  currentMonth={losAngelesDate.month}
                  currentYear={losAngelesDate.year}
                />
              ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default MyCoupons;
